import React from 'react'
import PropTypes from 'prop-types'
import { useTheme } from 'styled-components'
import Instance from 'highcharts'
import MoreAddOn from 'highcharts/highcharts-more'
import HighCharts from 'highcharts-react-official'
import { GlobalStyle, Root } from './BubblesChart.styles'

MoreAddOn(Instance)

/**
 * The BubblesChart's component.
 */
const BubblesChart = props => {
  const { categories, color, data, id, tooltipFormatter } = props
  const theme = useTheme()
  const options = {
    accessibility: { enabled: false },
    chart: { plotBorderWidth: 1, type: 'bubble', zoomType: 'xy' },
    legend: { enabled: false },
    plotOptions: {
      bubble: { maxSize: 45, minSize: 10 },
      series: {
        marker: {
          fillColor: color || theme.palette.charts.cinnabar,
          fillOpacity: 0.8,
          lineWidth: 2,
          lineColor: color || theme.palette.charts.cinnabar,
          opacity: 1
        },
        states: { hover: { enabled: false } }
      }
    },
    series: [{ data, maxSize: 50, minSize: 1, sizeBy: 'width' }],
    title: { text: '' },
    tooltip: { borderWidth: 1, formatter: tooltipFormatter, shadow: true },
    xAxis: { categories, gridLineWidth: 1 },
    yAxis: {
      endOnTick: false,
      maxPadding: 0.2,
      plotLines: [{ color: 'black', dashStyle: 'dot', width: 2, zIndex: 3 }],
      startOnTick: false,
      title: { text: '' }
    }
  }

  return (
    <>
      <GlobalStyle />
      <Root id={id}>
        <HighCharts highcharts={Instance} options={options} />
      </Root>
    </>
  )
}

BubblesChart.defaultProps = {
  color: undefined
}

BubblesChart.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.string).isRequired,
  color: PropTypes.string,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      x: PropTypes.number,
      y: PropTypes.number,
      z: PropTypes.number
    })
  ).isRequired,
  id: PropTypes.string.isRequired,
  tooltipFormatter: PropTypes.func.isRequired
}

export default BubblesChart
